document.addEventListener('DOMContentLoaded', () => {
    // Only run this script inside the new mega menu to prevent conflicts
    const megaNav = document.getElementById('mega-navigation');
    if (!megaNav) return;

    const mediaQueryList = window.matchMedia('(max-width: 1280px)');

    /* =========================================================
       1. DESKTOP LOGIC (Hover Intent, Clicks & ARIA)
    ========================================================= */
    const desktopDropdowns = megaNav.querySelectorAll('.navbar-item.has-dropdown');

    desktopDropdowns.forEach(item => {
        const link = item.querySelector('.navbar-link'); 
        const dropdown = item.querySelector('.navbar-dropdown');
        let itemTimer; 

        // --- HOVER TO OPEN ---
        item.addEventListener('mouseenter', () => {
            if (!mediaQueryList.matches) {
                clearTimeout(itemTimer); 
                if (dropdown) dropdown.style.display = '';
                
                // Close all other menus and strip legacy classes
                desktopDropdowns.forEach(otherItem => {
                    if (otherItem !== item) {
                        otherItem.classList.remove('is-active-menu', 'is-active'); 
                        const otherLink = otherItem.querySelector('.navbar-link');
                        if (otherLink) otherLink.setAttribute('aria-expanded', 'false');
                    }
                });

                item.classList.add('is-active-menu');
                if (link) link.setAttribute('aria-expanded', 'true');
            }
        });

        // --- HOVER AWAY TO CLOSE ---
        item.addEventListener('mouseleave', () => {
            if (!mediaQueryList.matches) {
                itemTimer = setTimeout(() => {
                    item.classList.remove('is-active-menu', 'is-active');
                    if (link) link.setAttribute('aria-expanded', 'false');
                    if (dropdown) dropdown.style.display = '';
                }, 150); 
            }
        });

        // --- CLICK TO CLOSE ---
        if (link) {
            link.addEventListener('click', (e) => {
                if (!mediaQueryList.matches) {

                    const isOpen = item.classList.contains('is-active-menu') || item.classList.contains('is-active');

                    if (isOpen) {
                        e.preventDefault(); 
                        e.stopImmediatePropagation(); 

                        if (dropdown) {
                            dropdown.style.setProperty('display', 'none', 'important');
                        }
                        
                        // Strip the classes
                        item.classList.remove('is-active-menu', 'is-active');
                        link.setAttribute('aria-expanded', 'false');
                        link.blur(); 

                        setTimeout(() => {
                            item.classList.remove('is-active', 'is-active-menu');
                        }, 10);
                    }
                }
            });
        }
    });

    /* =========================================================
       2. MOBILE LOGIC (Accordion Click Toggle)
       ========================================================= */

    // Accordion Toggle
    desktopDropdowns.forEach(el => {
        const link = el.querySelector('.navbar-link');
        if(link) {
            link.addEventListener('click', (e) => {
                if (mediaQueryList.matches) {
                    e.preventDefault(); 
                    const isCurrentlyActive = el.classList.contains('is-active-menu');
                    
                    // Close all others
                    megaNav.querySelectorAll('.navbar-item.has-dropdown').forEach(dropdown => {
                        dropdown.classList.remove('is-active-menu');
                        const dpLink = dropdown.querySelector('.navbar-link');
                        if (dpLink) dpLink.setAttribute('aria-expanded', 'false');
                    });

                    // Toggle the clicked one
                    if (!isCurrentlyActive) {
                        el.classList.add('is-active-menu');
                        link.setAttribute('aria-expanded', 'true');
                    } else {
                        link.setAttribute('aria-expanded', 'false');
                        el.classList.remove('is-active-menu', 'is-active');
                        link.blur(); 
                    }
                }
            });
        }
    });

    /* =========================================================
       3. CLEANUP ON RESIZE
       ========================================================= */
    mediaQueryList.addEventListener('change', (event) => {
        megaNav.querySelectorAll('.is-active, .is-active-menu').forEach(el => {
            el.classList.remove('is-active');
            el.classList.remove('is-active-menu');
        });
    });
});